export default __webpack_public_path__ + "static/media/LeePennHan_Resume.caa54eb2.pdf";